module["exports"] = [
  "6##-###-###",
  "6##.###.###",
  "6## ### ###",
  "6########"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/cell_phone/formats.js
 ** module id = 593
 ** module chunks = 0
 **/